// Work.js
import React from 'react';
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import {useNavigate} from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';
import Carousel from '../component/Carousel';
import AI_Carousel from '../component/AI_Csrousel';

function Work() {
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
        <section className='WorkHeaderWrapper'>
          <div className='WorkHeader'>
            <p className='SmHeading'>
              SERVICES
            </p>
            <p className='BigHeading'>
              RECENT PROJECTS
            </p>
            <p className='SmTxt SHeaderSmTxt'>
              Three disciplines. One studio. Infinite possibilities.
            </p>
          </div>
        </section>
        <section className='WorkBody'>
          <p className='SmHeading'>
            SELECTED WORK
          </p>
          <p className='BigHeading' id='Web'>
            Web design/development
          </p>
          <Carousel/>
          <p className='BigHeading' id='AI'>
            AI Content
          </p>
          <AI_Carousel/>
          <div className='WorkDownWrapper'>
            <p className='BigTxt'>
              READY TO START A PROJECT?
            </p>
            <button className='ContactBtn' onClick={() => navigate("/contact")}>Let's Talk →</button>
          </div>
        </section>

        <Footer/>
    </div>
  )
}

export default Work
